import styles from "@/components/premium-card.module.css";
import ProductIcon from "@/components/product-icon";
import * as signals from "@/signals";
import { PremiumApp, PremiumInfo } from "@/types";
import { openPopup } from "@/utils";
import {
	faCircleCheck,
	faCircleExclamation,
	faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import { JSX } from "react";

const PREMIUM_APP_TO_ENGLISH_NAME = Object.freeze({
	[PremiumApp.AIRPORTAL]: "AirPortal",
	[PremiumApp.WEB_HOSTING]: "Web Hosting",
});

interface PremiumCardProps {
	item: PremiumInfo;
}

function PremiumCard({ item }: PremiumCardProps): JSX.Element {
	const { appName, data, days, explanation, link, privileges } = item;

	const handleWhyPremiumClick = (): void => {
		signals.currentPrivilegesInfo.value = {
			appName,
			explanation,
			privileges,
		};
		openPopup("privileges");
	};

	const toGB = (bytes?: number): string => {
		if (!bytes) {
			return "0.00";
		}
		return (bytes / 1073741824).toFixed(2);
	};

	const watermarkAppName = appName
		? PREMIUM_APP_TO_ENGLISH_NAME[appName]
		: "";

	return (
		<div className={styles["premium-card"]}>
			<div
				aria-hidden="true"
				className={styles["watermark"]}
			>
				{watermarkAppName}
				<br />
				Premium
			</div>
			<div className={styles["card-body"]}>
				<a
					className={styles["link"]}
					href={link}
					rel="noreferrer"
					target="_blank"
				>
					<ProductIcon
						hasShadow
						product={appName}
						size={32}
					/>
					<span>{appName && t(appName)}</span>
				</a>
				<div className={styles["info"]}>
					{(days && days > 0) || data ? (
						<>
							<FontAwesomeIcon icon={faCircleCheck} />
							{t("youHavePremiumBenefits")}
						</>
					) : (
						<>
							<FontAwesomeIcon icon={faCircleExclamation} />
							{t("youDoNotHavePremiumBenefitsCurrently")}
						</>
					)}
					<br />
					{days !== undefined &&
						t("premiumDaysRemaining", {
							days: days,
						})}
					{data !== undefined &&
						t("premiumDataRemaining", {
							data: toGB(data),
						})}
				</div>
			</div>
			<button
				className="action-button privilege"
				type="button"
				onClick={handleWhyPremiumClick}
			>
				<FontAwesomeIcon
					icon={faStar}
					fixedWidth
				/>
				<span>{t("whyPremium")}</span>
			</button>
		</div>
	);
}

export default PremiumCard;
